const possibleLogLevels = ['debug', 'info', 'warn', 'error'] as const;

export default possibleLogLevels;
